module.exports = __webpack_public_path__ + "static/video-thumbnail-de1e25dccbcfec495329cc3c879ddaa9.jpg";